export default __webpack_public_path__ + "assets/1526908ed02528471f68f18746686749.svg";